const descs = {
  LogoOptions: "Logo"
};

export default descs;
